import { useFormikContext } from 'formik';
import { Button, Form } from 'react-bootstrap';
import { FaPlus } from 'react-icons/fa6';
import ReactInput from '../../../InputList/ReactInput/ReactInput';
import DeleteSingleItems from '../../../Modal/DeleteSingleItems';
import ReactDataTable from '../../../ReactDataTable/ReactDataTable';

const IconListAdd = ({ arrayHelpers }) => {
    const { values, setFieldValue } = useFormikContext();
    const columns = [
        {
            name: 'Title',
            cell: (_, i) => <ReactInput name={`iconData[${i}.title]`} />,
        },
        {
            name: 'Icon Class Name',
            cell: (_, i) => <ReactInput name={`iconData[${i}.icon]`} />,
        },
        {
            name: 'Link',
            cell: (_, i) => <ReactInput name={`iconData[${i}.link]`} />,
        },
        {
            name: 'Status',
            center: 'true',
            cell: (row, i) => (
                <Form.Check
                    checked={row?.status === 1}
                    onChange={(e) =>
                        setFieldValue(`iconData[${i}].status`, e.target.checked ? 1 : 0)
                    }
                />
            ),
        },
        {
            name: 'Remove',
            center: 'true',
            cell: (_, i) => <DeleteSingleItems handleDelete={() => arrayHelpers.remove(i)} />,
        },
    ];

    return (
        <div>
            <div className='d-flex justify-content-between align-items-center mb-3'>
                <h5>Social Media Icon List</h5>
                <Button
                    variant='teal'
                    onClick={() =>
                        arrayHelpers.push({
                            title: '',
                            icon: '',
                            link: '',
                            status: 1,
                        })
                    }
                >
                    <FaPlus />
                </Button>
            </div>
            <ReactDataTable columns={columns} data={values.iconData} />
        </div>
    );
};

export default IconListAdd;
